
// import b from '../../public/sounds/back.wav';

export function playSound(name: string) {
    const sound = new Audio(`${process.env.PUBLIC_URL}/sounds/${name}.wav`);
    sound.play();
}
